import { RTEInitValue } from '@talentmesh/rte';
import type { AutocompleteOption } from '@talentmesh/ui/components/autocomplete-chips';
import { JobAdSkillsDTO } from '@/DTO/Assessments/JobAdSkillsDTO';
import { DefaultWriteJobAdDTO, WriteJobAdDTO } from '@/DTO/Assessments/WriteJobAdDTO';
import { AssessmentStatuses } from '@/Models/AssessmentData';
import JobAdSkillsType from '@/Models/JobAdSkillsType';
import autoMapping from '@/Utils/autoMapping';

export interface JobAd {
    title: string;
    description: string;
    descriptionLen: number;
    hardSkills: AutocompleteOption[];
    hardSkillsSwitch: boolean;
    softSkills: AutocompleteOption[];
    softSkillsSwitch: boolean;
    companyDescription: string;
    status: AssessmentStatuses;
}

export const DefaultJobAd: JobAd = {
    title: '',
    description: RTEInitValue, // we use this initial value for correct RTE behavior
    descriptionLen: 0,
    hardSkills: [],
    hardSkillsSwitch: false,
    softSkills: [],
    softSkillsSwitch: false,
    companyDescription: RTEInitValue,
    status: AssessmentStatuses.Active,
};

const isNullOrUndefined = (value?: string | null) => {
    return value === undefined || value === null || value === '';
};

const toSkillId = (id?: string): number | undefined => {
    if (isNullOrUndefined(id)) {
        return undefined;
    }

    return Number(id);
};

export function mapJobAdModel2Dto(model: JobAd): WriteJobAdDTO {
    const dto = autoMapping(model, DefaultWriteJobAdDTO);
    const { hardSkills, hardSkillsSwitch, softSkills, softSkillsSwitch } = model;

    dto.skills = hardSkillsSwitch
        ? hardSkills.map((skill): JobAdSkillsDTO => ({
              id: toSkillId(skill.id),
              skillName: skill.label,
              skillType: JobAdSkillsType.HardSkill,
              isUserDefined: isNullOrUndefined(skill.id),
          }))
        : [];

    dto.skills = dto.skills.concat(
        softSkillsSwitch
            ? softSkills.map((skill): JobAdSkillsDTO => ({
                  id: toSkillId(skill.id),
                  skillName: skill.label,
                  skillType: JobAdSkillsType.SoftSkill,
                  isUserDefined: isNullOrUndefined(skill.id),
              }))
            : [],
    );

    return dto;
}
